import { render, staticRenderFns } from "./TableUnionPager.vue?vue&type=template&id=3bcbf6be&scoped=true&"
import script from "./TableUnionPager.vue?vue&type=script&lang=js&"
export * from "./TableUnionPager.vue?vue&type=script&lang=js&"
import style0 from "./TableUnionPager.vue?vue&type=style&index=0&id=3bcbf6be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbf6be",
  null
  
)

export default component.exports